import { RidangoReduxAction } from '@ridango/core';

import { tassign } from 'tassign';

import { MediumType, TravelCardType } from '../medium.model';
import { MediumActions } from './medium.actions';

export const PURCHASE_MEDIUM_STATE_KEY = 'purchaseMedium';

export interface PurchaseMediumState {
    availableMediumGroups: any[];
    selectedMediumGroup: any;
    cardTypeMask: number;
    selectedMedium: {
        type: MediumType;
        relatedCardId?: number;
        cardId?: string;
        cardType?: TravelCardType;
        email?: string;
        sms?: string;
    };

}

export const PURCHASE_MEDIUM_INITIAL_STATE: PurchaseMediumState = {
    availableMediumGroups: [],
    selectedMediumGroup: null,
    cardTypeMask: null,
    selectedMedium: {
        type: null,
        relatedCardId: null,
        cardId: null,
        cardType: null,
        email: null,
        sms: 'N',
    }

};

export function purchaseMediumReducer(
    state: PurchaseMediumState = PURCHASE_MEDIUM_INITIAL_STATE,
    action: RidangoReduxAction
): PurchaseMediumState {
    switch (action.type) {
        case MediumActions.SET_SELETED_MEDIUM:
            // return {
            //     ...state,
            //     ...action.payload,
            // };
            return tassign(state, {
                selectedMedium: {
                    ...state.selectedMedium,
                    ...action.payload
                }
            });

        case MediumActions.SET_CARD_TYPE_MASK:
            return tassign(state, {
                cardTypeMask: action.payload
            });

        case MediumActions.SET_AVAILABLE_MEDIUM_GROUPS:
            return tassign(state, {
                availableMediumGroups: action.payload
            });
        case MediumActions.SET_SELECTED_MEDIUM_GROUP:
            return tassign(state, {
                selectedMediumGroup: action.payload
            });
        case MediumActions.RESET_SELECTED_MEDIUM:
            return tassign(state, {
                selectedMedium: { ...PURCHASE_MEDIUM_INITIAL_STATE.selectedMedium }
            });
        case MediumActions.CLEAR_MEDIUM:
            return {
                ...state,
                ...PURCHASE_MEDIUM_INITIAL_STATE,
            };
    }

    return state;
}

export interface PurchaseMediumPartialStoreState {
    [PURCHASE_MEDIUM_STATE_KEY]: PurchaseMediumState;
}
